/**
 * Created by lihanying on 2017/7/6.
 */
import {
  GETPAYMENTLIST,
  GETBUSINESS,
  GETPERIOD,
  GETRECORDDETAIL,
  GETINCOMESUM,
  UPDATE_PURCHASE_SERVICES,
  GETBILLREMARKS,
  GETBILLREMARKSUM,
} from './constants'

const initState = { incomeSumList: [], billRemarkSumList: [] }

export default function (state = initState, action) {
  switch (action.type) {
    case GETPAYMENTLIST:
      return Object.assign({}, state, { paymentList: action.payload })
    case GETBUSINESS:
      return Object.assign({}, state, { business: action.payload })
    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })
    case GETRECORDDETAIL:
      return Object.assign({}, state, { recordDetail: action.payload })
    case GETINCOMESUM:
      return Object.assign({}, state, { incomeSumList: action.payload })
    case UPDATE_PURCHASE_SERVICES:
      return Object.assign({}, state, { serviceList: action.payload })
    case GETBILLREMARKS:
      return Object.assign({}, state, { billRemarkList: action.payload })
    case GETBILLREMARKSUM:
      return Object.assign({}, state, { billRemarkSumList: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/reduce.js